<div class="progress-pie-doughnut" [ngClass]="fillClass" [style]="'width: '+elementWidth+'%'">
  <svg width="100%" height="100%" viewBox="0 0 40 40" class="doughnut">
    <circle class="doughnut-ring" [ngClass]="fillClass" cx="20" cy="20" r="16" fill="blue" stroke-width="8"></circle>
    <circle class="doughnut-segment stroke" [ngClass]="fillClass" cx="20" cy="20" r="16" stroke-width="8" stroke-dashoffset="24.8" [style.strokeDasharray]="progressPercent || progressPercent === 0 ? progressPercent+' '+(100-progressPercent) : null"></circle>
    <circle class="doughnut-hole" cx="20" cy="20" r="16.1"></circle>
  </svg>
  @if (icon && (text === null || text === undefined)) {
    <div class="icon-holder">
      @if (icon.identifier_1) {
        <i [class]="icon.identifier_1"></i>
      }
      @if (!icon.identifier_1 && icon.identifier_2) {
        <img [src]="cloudinary_base_url+'w_32,c_fill,ar_1:1,r_max/'+icon.identifier_2+'.svg'" class="mr-1">
      }
    </div>
  }
  @if (text === 0 || text) {
    <div class="icon-holder" [style]="'--fontSize:'+fontSize">
      {{text}}
    </div>
  }
</div>